module.exports = __webpack_public_path__ + "static/cloudBg-3f30cbb38960148f3984907e7e312279.jpg";